import React from "react";

const Layout = ({ children }) => {
  return <div className='grid place-items-center bg-blue-100 h-screen px-6 font-sans'>{children}</div>;
};

export default Layout;
